import type { TimelineItem } from '@/mocks/topics';

interface TimelineProps {
  items: TimelineItem[];
}

export default function Timeline({ items }: TimelineProps) {
  return (
    <ol className="relative space-y-6 border-l border-background-300 pl-6">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <li key={item.time} className="relative">
            <span
              className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 ${
                isLast ? 'bg-primary-500' : 'bg-accent-500'
              }`}
              aria-hidden="true"
            ></span>
            <p className="font-label text-xs font-medium text-primary-600">{item.time}</p>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{item.text}</p>
          </li>
        );
      })}
    </ol>
  );
}